import CommonService from '../../services/commonService';
import React from 'react';

const cormarbusChangeTicketPolicy = [
	'Los cambios de pasaje solo podrán realizarse hasta ocho (8) horas antes de la hora de salida del viaje',
	'No estarán permitidos cambios de pasajes dentro de las últimas ocho (8) horas antes de la hora de salida del viaje.',
	'Los cambios de pasaje generan un reembolso de 100% del valor del pasaje cambiado a la cuenta o billetera CormarPay. Este saldo estará disponible para una nueva compra en www.cormarbus.cl.',
	'Los reembolsos por cambios de pasaje solo podrán realizarse a la cuenta del titular del pasaje cambiado.',
];
const santajuanaChangeTicketPolicy = [
	'Al cambiar un pasaje recibirás el 100% de la devolución en tu billetera SantaJuanaPay', 'La devolución será inmediata y se verá reflejada en tu billetera, quedando el saldo disponible para futuras compras.',
];



const CancellationPolicyBlock = props => {
	const { t, paymentOptions } = props;
	const isChangeTicket = localStorage.getItem('isChangeTicket') == 'true' ? true : false;
	let operator = JSON.parse(localStorage.getItem('metaData') || '{}') || props.operator;

	let operatorName =
		operator &&
		operator.operator_sites &&
		operator.operator_sites.operator &&
		operator.operator_sites.operator.operator_name;

	let operatorLabel = CommonService.getOperatorPaymentLabel(props.operator) ? CommonService.getOperatorPaymentLabel(props.operator) : 'kupospay'

	let cancelTicketPolicy = [
		'CANCEL_TICKET.POLICY_BUS_1',
		'CANCEL_TICKET.POLICY_BUS_2',
		'CANCEL_TICKET.POLICY_BUS_3',
		// `Todos los reembolsos, excepto los realizados a ${operatorLabel.toLowerCase()}, tienen un cargo adicional de CLP $600 por costos administrativos y bancarios.` ,
		'CANCEL_TICKET.POLICY_BUS_5',
	]


	const getPolicy = () => {
		if (operatorName === 'cormarbus') {
			return isChangeTicket ? cormarbusChangeTicketPolicy : cancelTicketPolicy
		}
		if (operatorName === 'santajuana') {
			return isChangeTicket ? santajuanaChangeTicketPolicy : cancelTicketPolicy
		}
		else {
			return cancelTicketPolicy;
		}
	};

	const pay = CommonService.getOperatorPaymentLabel(operator)
		? CommonService.getOperatorPaymentLabel(operator)
		: '';

	return (
		<div className="cancellation-cancellation-policy-block font10">
			<div className="pol-title">
				<span className="bold-text upper-case-text">
					{t('CANCEL_TICKET.IMPORTANT_INFORMATION')}
				</span>
			</div>
			{paymentOptions && paymentOptions.paypalSelected ? (
				<div>
					{' '}
					<span className="bold-text ">{t('CANCEL_TICKET.PAYPAL_REFUND.BOLD')}</span>{' '}
					{t('CANCEL_TICKET.PAYPAL_REFUND.NORMAL')}
				</div>
			) : null}
			{paymentOptions && paymentOptions.pbCashSelected ? (
				<div>
					{' '}
					<span className="bold-text ">
						{CommonService.getCancelTicketRefundText(props.operator).bold}
					</span>{' '}
					{CommonService.getCancelTicketRefundText(props.operator).normal}
				</div>
			) : null}
			{paymentOptions && paymentOptions.bankSelected ? (
				<div>
					{' '}
					<span className="bold-text ">{t('CANCEL_TICKET.DEPOSIT_REFUND.BOLD')}</span>{' '}
					{t('CANCEL_TICKET.DEPOSIT_REFUND.NORMAL')}
				</div>
			) : null}
			{paymentOptions && paymentOptions.creditCardSelected ? (
				<div>
					{' '}
					<span className="bold-text ">{t('CANCEL_TICKET.CREDIT_CARD_REFUND.BOLD')}</span>{' '}
					{t('CANCEL_TICKET.CREDIT_CARD_REFUND.NORMAL')}
				</div>
			) : null}
			<div className="pol-title">
				<span className="bold-text  upper-case-text">

					{/* {isChangeTicket && (operator && operator.operator_name === "santajuana") ? 'POLÍTICAS DE CAMBIO:' : ('NEW_POLICY') : t('CANCEL_TICKET.CANCELLATION_POLICIES')} */}


					{/* //{isChangeTicket ? 'POLÍTICAS DE CAMBIO:' : t('CANCEL_TICKET.NEW_POLICY').replace('#paylabelname#', pay)} */}
				</span >
			</div >
			<ul className="sub-item-list my-1">
				{getPolicy().map((policy) => {
					console.log(policy)
					return <li>
						<span className="bullet">•</span> <span>{t(policy)}</span>
					</li>
				})}

				{/* <li>
          <span className="bullet">•</span> <span>{t('CANCEL_TICKET.POLICY_BUS_2')}</span>
        </li>
        <li>
          <span className="bullet">•</span> <span>{t('CANCEL_TICKET.POLICY_BUS_3')}</span>
        </li>
        <li>
          <span className="bullet">•</span>{' '}
          <span>
            {operatorName == 'cormarbus'
              ? t('CANCEL_TICKET.POLICY_BUS_4_CORMARPAY')
              : t('CANCEL_TICKET.POLICY_BUS_4')}
          </span>
        </li>
        <li>
          <span className="bullet">•</span> <span>{t('CANCEL_TICKET.POLICY_BUS_5')}</span>
        </li> */}
			</ul>
		</div >
	);
};

export default CancellationPolicyBlock;



// WEBPACK FOOTER //
// ./src/features/cancellation/CancellationPolicyBlock.js